import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FormFieldWrapperComponent } from '@shared/dot-form-field-wrapper/dot-form-field-wrapper.component';
import {
  ErrorStateMatcher,
  JbContextualHelpModule,
  JbErrorModule,
  JbFormFieldContainerModule,
  JbIconModule,
  JbInputModule,
  JbSelectModule,
  ShowOnSubmitErrorStateMatcher,
} from 'jb-component-library';

import { UIModule } from '../../shared/ui';
import { StoreService } from '../../store/shared/store.service';
import {
  ContactUsComponent,
  contactUsContainerResolver,
} from './contact-us.component';
import { ContactUsEffects } from './store/contact-us.effects';
import {
  CONTACT_US_FACADE,
  getContactUsFacade,
} from './store/contact-us.facade';
import { featureKey, featureReducer } from './store/contact-us.reducer';

const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  UIModule,
  JbIconModule,
  JbInputModule,
  JbSelectModule,
  JbFormFieldContainerModule,
  JbErrorModule,
  JbContextualHelpModule,
  FormsModule,
];
const DECLARATIONS = [ContactUsComponent];

@NgModule({
  imports: [
    ...MODULES,
    FormFieldWrapperComponent,
    StoreModule.forFeature(featureKey, featureReducer.contactUsForm),
    EffectsModule.forFeature([ContactUsEffects]),
  ],
  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS],
  providers: [
    { provide: ErrorStateMatcher, useClass: ShowOnSubmitErrorStateMatcher },
    {
      provide: CONTACT_US_FACADE,
      useFactory: getContactUsFacade,
      deps: [StoreService],
    },
  ],
})
export class ContactUsModule {
  static entry = ContactUsComponent;
  static componentDataResolver = contactUsContainerResolver;
}
